/** Typy pri zatackach */
export const enum CurveType {

  end = 'end',
  start = 'start'

}
